import { FC } from 'react'

export const HeaderSubheader: FC<{
  title: string
  text?: string
  className?: string
  titleClassName?: string
}> = ({ title, text, className, titleClassName }) => {
  return (
    <div className={`sm:flex-auto flex flex-col gap-1 ${className}`}>
      <h1 className={`text-xl font-semibold text-black ${titleClassName}`}>
        {title}
      </h1>
      {text && <p className="text-base font-normal text-sec-black">{text}</p>}
    </div>
  )
}
